import { Component } from '@angular/core';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'vorab-check-component',
  templateUrl: '../sharedTemplates/vorab-check.html',
})
export class VorabCheckComponent {
  amount = 2;
  searchTicketNumberSubject = new Subject<any>();
  constructor(public _UiHelper: UiHelper, public _UserHelper: UserHelper, private _ApiService: ApiService, public _DataHelper: DataHelper, private _Router: Router) {
    this.searchTicketNumberSubject
      .pipe(
        debounceTime(500) // 500ms debounce süresi
      )
      .subscribe(() => {
        this.getSearchTicketNumber();
      });
    this._Router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.url.split('/');
        if (url && url.length > 0) {
          if (url[1] === 'home' && url[2]) {
            setTimeout(() => {
              this._UiHelper.bookingCode = url[2];
              this.getSearchTicketNumber();
            }, 5000);
          }
        }
      }
    });
  }
  onSearchClick() {
    this.searchTicketNumberSubject.next();
  }
  getSearchTicketNumber() {
    try {
      if (this._UiHelper.bookingCode.toString().startsWith('500')) {
        this._UiHelper.bookingCode = this._UiHelper.bookingCode.toString().substring(3);
      }
      this._ApiService.getSearchSlipNumber(this._UiHelper.bookingCode).then(x => {
        if (x && x.GridData && x.Amount && !Number.isNaN(Number(x.Amount))) {
          this._DataHelper.currentSlipVorabOdd = x.GridData;
          this.amount = parseInt(x.Amount, 10);
        }
        this.getCustomerSlipDetailTemp(this._UiHelper.bookingCode);
        this.clickNewOdd(this._DataHelper.currentSlipVorabOdd);
      });
    } catch (error) {
      console.error(error);
    }
  }

  getCustomerSlipDetailTemp(slipId) {
    this._ApiService.getCustomerSlipDetailTemp(slipId).then(x => {
      let tabId: 0 | 1 | 2;

      if (!Array.isArray(x) || x.length === 0) return;

      this._DataHelper.currentSlipVorabTicket = x;
      if (x[0].SlipTypeId === 2 || x[0].SlipTypeId === 5) {
        tabId = 1;
      } else {
        tabId = 2;
      }
      this._UiHelper.currentSlipTabSelected = tabId;
      this._UiHelper.setCurrentSlipTabSelected(tabId);
    });
  }
  clickNewOdd(data) {
    if (!Array.isArray(data)) return;
    const slipstring = JSON.stringify([]);
    localStorage.setItem('currentslip', slipstring);
    const currentSlipString = localStorage.getItem('currentslip');
    if (currentSlipString !== null) {
      this._ApiService.slipCurrents = JSON.parse(currentSlipString);
    } else {
      this._ApiService.slipCurrents = [];
    }
    data.forEach(element => {
      const newOdd = {
        Banko: element.Banko,
        BetType: 0,
        Enable: true,
        EventDateLong: element.EventDate,
        EventName: element.EventName.split('-')[0] + ' - ' + element.EventName.split('-')[1],
        MatchId: element.MatchId,
        OddId1: element.OddId1,
        OddsType: element.OddsType,
        OddsTypeId: element.OddsTypeId,
        OddValue1: element.OddValue1,
        OutCome: element.OutCome,
        ShortOddType: element.ShortOddType,
        SpecialBetValue: element.SpecialBetValue,
        Visibility: '',
        HomeTeam: element.EventName.split('-')[0],
        AwayTeam: element.EventName.split('-')[1],
      };

      this._ApiService.addOddDirectlyWithoutNotify(newOdd);
    });
    this._ApiService.getCurrentSlip();

    this._UiHelper.closeAllMenus();
    this._UiHelper.p1001SetMatchDetailDialog('close');
    this._UiHelper.p1001SetBottomDialogState('open');
  }
}
